// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1_tzF","inner":"Footer_inner__34B2m","nextIcon":"Footer_nextIcon__3peub","innerLeft":"Footer_innerLeft__2LJs9"};